// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f1-a";
export var fulfillmentFormRail = "_f1-9";
export var headerTitleRow = "_f1-c";
export var orderDetailsWrapper = "_f1-7";
export var orderLinkTrigger = "_f1-2";
export var paymentInformationGrid = "_f1-h";
export var paymentSummaryColumn = "_f1-i";
export var shipmentContainer = "_f1-b";
export var shipmentDetailsMainPane = "_f1-8";
export var shipmentNavigationCard = "_f1-5";
export var shipmentNavigationRail = "_f1-3";
export var shipmentNavigationRailHeader = "_f1-4";
export var shipmentSummaryFact = "_f1-e";
export var shipmentSummaryGrid = "_f1-d";
export var shipmentSummaryMetadataRow = "_f1-f";
export var shipmentSummaryTags = "_f1-g";
export var shipmentWorkspace = "_f1-0";
export var shipmentWorkspaceContent = "_f1-6";
export var shipmentWorkspaceHeader = "_f1-1";